import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ImportEstimation/components/ImportEstimationSwitchProject/ImportEstimationSwitchProject.styled.ts",
    _templateObject2;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
export var ProjectSourceBubble = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 3px;\n  background: rgba(53, 59, 96, 0.1);\n  font-family: Roboto, sans-serif;\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 10px;\n  text-align: left;\n  border-radius: 4px;\n  color: #353b60;\n  height: min-content;\n"])));
export var BadgeLabel = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 4px;\n"])));